import { useState } from "react";

export default function useFormData( default_data ) {

   const [ data, _setData ] = useState( default_data || {});
   const [ errors, setErrors ] = useState({});

   const onDataChange = ( name, value ) => {

      if ( typeof name === "string" ) {
         _setData( d => ({ ...d, [ name ]: value }));
         setErrors( err => ({ ...err, [ name ]: "" }));
      } else {

         const form_data = name;

         _setData( d => ({ ...d, ...form_data }));
         setErrors( err => {

            Object.keys( form_data ).forEach(n => {
               err[n] = "";
            });

            return { ...err };
         })
      }
   }

   const clearData = () => {
      _setData({});
      setErrors({})
   }

   const setData = d => {
      _setData({ ...d });
      setErrors({});
   }

   return {
      data,
      errors,

      onDataChange,
      clearData,
      setData,
      setErrors
   };
}